import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icon.d.ts').IconArrowRight}
 */
const IconArrowRight = ({
    height = 32,
    width = 32
}) => {
    return (
        <svg
            aria-hidden='true'
            className='icon-arrow transition-all'
            fill='none'
            height={height}
            viewBox='0 0 20 20'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M4.83398 10.3346L13.8788 10.3346L9.53107 14.6823L10.0007 15.168L15.1673 10.0013L10.0007 4.83463L9.53107 5.32026L13.8788 9.66797L4.83398 9.66797L4.83398 10.3346Z'
                fill='currentColor' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default IconArrowRight;
